/*
 *  Dismissible guide card for wizard steps.
 *  Follows the WelcomeWidget pattern — once dismissed, stays hidden via localStorage.
 *
 *  Props:
 *  - guideId:  string  — unique key for this guide (stored in swb-dismissed-guides)
 *  - title:    string  — card heading
 *  - children: node    — card body content
 */

import React from 'react';
import { Icon } from 'semantic-ui-react';
import { isGuideDismissed, dismissGuide } from './DismissedGuides';

const iconStyle = { margin: 0, lineHeight: 1, height: '1em' };

class StepGuideCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = { dismissed: isGuideDismissed(props.guideId) };
  }

  handleDismiss = () => {
    dismissGuide(this.props.guideId);
    this.setState({ dismissed: true });
  };

  render() {
    if (this.state.dismissed) return null;

    const { title, children } = this.props;

    return (
      <div className="workspace-card" style={{ overflow: 'hidden', marginBottom: '16px' }}>
        <div className="workspace-card-accent" style={{ background: 'var(--rmit-yellow)' }} />
        <div style={{ padding: '16px 20px', background: '#fffdf5' }}>
          <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '16px' }}>
            <div style={{ flex: 1 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
                <Icon name="lightbulb outline" style={{ ...iconStyle, color: '#92400e', fontSize: '1.1em' }} />
                <span style={{ fontSize: '0.95em', fontWeight: '600', color: '#92400e' }}>{title}</span>
              </div>
              <div style={{ fontSize: '0.88em', color: '#4b5563', lineHeight: '1.6' }}>
                {children}
              </div>
            </div>
            <button
              onClick={this.handleDismiss}
              aria-label="Dismiss guide"
              style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                padding: '4px',
                color: '#9ca3af',
                flexShrink: 0,
                lineHeight: 1,
              }}
            >
              <Icon name="close" style={{ ...iconStyle, fontSize: '1em' }} />
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default StepGuideCard;
